import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToWords } from 'to-words';

@Component({
  selector: 'app-viewreceiptpackagebook',
  templateUrl: './viewreceiptpackagebook.component.html',
  styleUrls: ['./viewreceiptpackagebook.component.scss']
})
export class ViewReceiptpackagebookComponent implements OnInit {

  // -------------------------
  // VARIABLES
  // -------------------------
  sellerData: any;
  book_data: any[] = [];
  inputValues: any[] = [];

  totalAmount = 0;
  totalInWords = '';
  receiptNo: any;
  today = new Date();
  seamt: any;
  receivedamt = 0;
  orderno: any;

  // -------------------------
  // CONSTRUCTOR
  // -------------------------
  constructor(
    private dialogRef: MatDialogRef<ViewReceiptpackagebookComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  // -------------------------
  // INIT
  // -------------------------
  ngOnInit(): void {

    console.log('Dialog Data:', this.data);

    // Data from parent
    this.sellerData   = this.data.formData;
    this.book_data    = this.data.bookData    || [];
    this.inputValues  = this.data.inputValues || [];

    this.totalAmount  = this.data.total_amt || 0;
    this.receiptNo    = this.data.formData?.recptno;
    this.seamt        = this.data.formData?.seamt;
    this.orderno      = this.data.formData?.orderno;
    // Same value shown in the list's "received amount" column (book.receivedamt)
    const fd = this.data.formData || {};
    this.receivedamt  = this.toNumber(fd.receivedamt)
                     || this.toNumber(fd.received_amt)
                     || this.toNumber(fd.recipt_amt)
                     || this.toNumber(fd.seamt);

    // Convert amount to words
    const toWords = new ToWords();
    this.totalInWords = toWords.convert(this.receivedamt, { currency: true });
  }

  // Handles numbers and strings like "1,500.00"
  private toNumber(val: any): number {
    if (val === null || val === undefined || val === '') return 0;
    const n = Number(String(val).replace(/,/g, ''));
    return isNaN(n) ? 0 : n;
  }

  // -------------------------
  // PRINT
  // -------------------------
  print(): void {
    window.print();
  }
}
